import { sportingAPI } from 'services/sporting/api';
import { UserInfo } from 'types/state';
import { normalizeSportingUserInfo } from '../utils/normalizeSportingUserInfo';

export const getEmployees = async (): Promise<UserInfo[]> => {
  const employees = await sportingAPI.service.getEmployees();

  return employees.map(normalizeSportingUserInfo.toUserInfo);
};
